export enum ConnectionResponsibility {
  OFFTAKER = 'OFFTAKER',
  DEVELOPER = 'DEVELOPER'
}
